import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
const DashboardV2Page = lazy(() => import("./pages/DashboardV2Page"));
const StockPage = lazy(() => import("./pages/StockPage"));
const AppareilDetailPage = lazy(() => import("./pages/AppareilDetailPage"));
const LotsAchatPage = lazy(() => import("./pages/LotsAchatPage"));
const LotAchatDetailPage = lazy(() => import("./pages/LotAchatDetailPage"));
const LotsVentePage = lazy(() => import("./pages/LotsVentePage"));
const LotVenteDetailPage = lazy(() => import("./pages/LotVenteDetailPage"));
const PreparationLotPage = lazy(() => import("./pages/PreparationLotPage"));
const PreparationsPage = lazy(() => import("./pages/PreparationsPage"));
const FournisseursPage = lazy(() => import("./pages/FournisseursPage"));
const ClientsPage = lazy(() => import("./pages/ClientsPage"));
const CommandesPage = lazy(() => import("./pages/CommandesPage"));
const CommandeDetailPage = lazy(() => import("./pages/CommandeDetailPage"));
const ParametresPage = lazy(() => import("./pages/ParametresPage"));
const BackMarketPage = lazy(() => import("./pages/BackMarketPage"));
const AtelierPage = lazy(() => import("./pages/AtelierPage"));
const UsersAdminPage = lazy(() => import("./pages/UsersAdminPage"));
const RolesAdminPage = lazy(() => import("./pages/RolesAdminPage"));
const ActivityPage = lazy(() => import("./pages/ActivityPage"));
const InventairePage = lazy(() => import("./pages/InventairePage"));
const InventaireDetailPage = lazy(() => import("./pages/InventaireDetailPage"));
const PerformancePage = lazy(() => import("./pages/PerformancePage"));
const LivePage = lazy(() => import("./pages/LivePage"));
import "./App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

const PageLoader = () => (
  <div className="flex items-center justify-center h-64">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

function AppRoutes() {
  return (
    <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/live" element={<ProtectedRoute><LivePage /></ProtectedRoute>} />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardV2Page />} />
        <Route path="stock" element={<StockPage />} />
        <Route path="stock/:id" element={<AppareilDetailPage />} />
        <Route path="inventaire" element={<InventairePage />} />
        <Route path="inventaire/:id" element={<InventaireDetailPage />} />
        <Route path="backmarket" element={<BackMarketPage />} />
        <Route path="lots-achat" element={<LotsAchatPage />} />
        <Route path="lots-achat/:id" element={<LotAchatDetailPage />} />
        <Route path="preparations" element={<PreparationsPage />} />
        <Route path="lots-vente" element={<LotsVentePage />} />
        <Route path="lots-vente/:id" element={<LotVenteDetailPage />} />
        <Route path="lots-vente/:id/preparation" element={<PreparationLotPage />} />
        <Route path="atelier" element={<AtelierPage />} />
        <Route path="fournisseurs" element={<FournisseursPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="commandes" element={<CommandesPage />} />
        <Route path="commandes/:id" element={<CommandeDetailPage />} />
        <Route path="parametres" element={<ParametresPage />} />
        <Route path="utilisateurs" element={<UsersAdminPage />} />
        <Route path="roles" element={<RolesAdminPage />} />
        <Route path="activite" element={<ActivityPage />} />
        <Route path="performance" element={<PerformancePage />} />
      </Route>
    </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
